/** Dispatch event on click outside of node */
export const clickOutside = (
    node: Element,
    props: { callback: CallableFunction; ignore?: HTMLElement[] }
): SvelteActionReturnType => {
    const handleClick = (event) => {
        if (
            node &&
            !node.contains(event.target) &&
            !event.defaultPrevented &&
            !(props.ignore && props.ignore.some((ignore) => ignore.contains(event.target)))
        ) {
            props.callback();
        }
    };

    document.addEventListener('pointerdown', handleClick, true);

    return {
        destroy() {
            document.removeEventListener('pointerdown', handleClick, true);
        },
    };
};
